const accordions = () => {
  const accordions = document.querySelectorAll('.accordions');

  accordions.forEach(accordion => {
    if (accordion.disabled) return;

    const triggers = accordion.querySelectorAll('.accordion__trigger');
    const panels = accordion.querySelectorAll('.accordion__panel');

    const handleClick = event => {
      // find the current trigger
      const trigger = event.target.closest('.accordion__trigger');
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      // if we haven't clicked on a trigger return
      if (!trigger) {
        return;
      }

      // find the current panel
      const panelId = trigger.getAttribute('aria-controls');
      const panel = accordion.querySelector(`#${panelId}`);

      // hide all panels
      triggers.forEach(trigger => trigger.setAttribute('aria-expanded', false));
      panels.forEach(panel => panel.setAttribute('hidden', true));

      if (!isExpanded) {
        // show the current panel
        trigger.setAttribute('aria-expanded', true);
        panel.removeAttribute('hidden');
      }
    };

    // attach event listener to the accordion itself
    accordion.addEventListener('click', handleClick);
  });

  // Some elements become accordions only on mobile;
  // This checks for elements with accordion--medium-down class
  // and if on mobile it add attributes to trigger and panel elements so the accordion functionality works
  const accordionsMobile = document.querySelectorAll('.accordion--medium-down');

  if (accordionsMobile.length === 0) return;

  const addAccordionAttr = elem => {
    elem.querySelector('.accordion__panel').setAttribute('hidden', true);
    elem.querySelector('.accordion__trigger').removeAttribute('disabled');
    elem.querySelector('.accordion__trigger').setAttribute('aria-expanded', false);
  };

  const removeAccordionAttr = elem => {
    elem.querySelector('.accordion__panel').removeAttribute('hidden');
    elem.querySelector('.accordion__trigger').disabled = true;
    elem.querySelector('.accordion__trigger').removeAttribute('aria-expanded');
  };

  const handleResize = e => {
    if (e.matches) {
      accordionsMobile.forEach(accordion => {
        addAccordionAttr(accordion);
      });
    } else {
      accordionsMobile.forEach(accordion => {
        removeAccordionAttr(accordion);
      });
    }
  };

  const mobileQuery = window.matchMedia(`(max-width: ${window.theme.breakpoints.medium}px)`);

  if (mobileQuery.matches) {
    accordionsMobile.forEach(accordion => {
      addAccordionAttr(accordion);
    });
  }

  mobileQuery.addListener(e => {
    handleResize(e);
  });
};

export default accordions;
